import {
  Range,
  Slider as RadixSlider,
  Thumb,
  Track,
} from '@radix-ui/react-slider';
import clsx from 'clsx';
import {forwardRef} from 'react';

export const Slider = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof RadixSlider> & {
    size?: 'sm' | 'md' | 'lg';
  }
>(({size, ...props}, forwardedRef) => {
  const value = props.value || props.defaultValue || [];

  return (
    <RadixSlider
      {...props}
      ref={forwardedRef}
      className={clsx(
        'relative flex touch-none items-center select-none',
        size === 'sm' ? 'h-3' : size === 'lg' ? 'h-8' : 'h-5'
      )}
    >
      <Track className={clsx("relative grow rounded-full bg-slate5",
        size === 'sm' ? 'h-0.5' : size === 'lg' ? 'h-2.5' : 'h-1.5'
      )}>
        <Range className="absolute h-full rounded-full bg-blue9" />
      </Track>

      {value.map((_, i) => (
        <Thumb
          key={i}
          className={clsx(
            'block cursor-pointer rounded-full bg-blue9 shadow-[0_2px_10px] shadow-black hover:bg-blue10 focus:outline-none',
            size === 'sm' ? 'size-3' : size === 'lg' ? 'size-8' : 'size-5'
          )}
        />
      ))}
    </RadixSlider>
  );
});
